import React, { useState, useEffect } from "react";
import successIcon from "../../../assets/images/success_lg.png";
import errorIcon from "../../../assets/images/error-2.png";
import allApi from "../../../api/allApi";
import Loader from "../common/Loader";
import waitIcon from "../../../assets/images/hourglass.png";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import $ from "jquery";
import InputMask from "react-input-mask";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../localization/LocalizationContext";
import NmsTableSearch, { searchRows, sortRows } from "../common/NmsTableSearch";

const DeviceDiscovery = ({ addDeviceToListing }) => {
  const { localizationStrings } = useLocalization();
  const [snmpFields, setSnmpFields] = useState({
    startIp: "",
    endIp: "",
    ipType: "",
    snmpID: "",
    snmpTemplate: "",
    snmpGateway: "",
  });
  const mqttDefaultValues = {
    start_ip: "",
    snmp_template: "",
    gateway_id: "",
    mac_address: "",
  };
  const [mqttFields, setMqttFields] = useState(mqttDefaultValues);
  const [tr069Fields, setTr069Fields] = useState({
    manufacturer: "",
    oui: "",
    serialNo: "",
    productClass: "",
  });
  const [httpsFields, setHttpsFields] = useState({
    serialNo: "",
    macAddress: "",
    deviceName: "",
    deviceType: "",
    networkId: "",
  });
  const [networkIds, setNetworkIds] = useState([]);

  const initialDiscoverResponseData =
    JSON.parse(localStorage.getItem("discoverResponseData")) || [];
  const [discoverResponseData, setDiscoverResponseData] = useState([]);

  const [snmpTemplates, setSnmpTemplates] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("snmp");
  const [showNoDeviceSelectedPopup, setShowNoDeviceSelectedPopup] =
    useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [deviceAddedMessageVisible, setDeviceAddedMessageVisible] =
    useState(false);
  const [showSuccessMessageModal, setShowSuccessMessageModal] = useState(false);
  const [mqttDeviceMessage, setMqttDeviceMessage] = useState("");
  const [gateways, setGateways] = useState([]);
  const [error, setError] = useState("");
  const [errorDiscovery, setErrorDiscovery] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isDiscoverButtonDisabled, setIsDiscoverButtonDisabled] =
    useState(true);
  const [isAddMqttDisabled, setIsAddMqttDisabled] = useState(true);
  const [isTRDisabled, setTRDisabled] = useState(true);
  const [isAddHttpDisabled, setIsAddHttpDisabled] = useState(true);
  const [isAddEdgeDisabled, setIsAddEdgeDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [discoverError, setDiscoverError] = useState(false);
  const macAddressRef = useRef(null);
  const [startIpError, setStartIpError] = useState("");
  const [endIpError, setEndIpError] = useState("");
  const [deviceManagedError, setDeviceManagedError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [devicesResponse, setDevicesResponse] = useState([]);
  const [deviceListings, setDeviceListings] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [tr069SuccessModal, setTr069SuccessModal] = useState(false);
  const [tr069ErrorModal, setTr069ErrorModal] = useState(false);
  const [tr069ErrorMessage, setTr069ErrorMessage] = useState("");
  const [showDeviceExistPopup, setShowDeviceExistPopup] = useState(false);
  const [showCreateNetworkModal, setShowCreateNetworkModal] = useState(false);
  const [newNetwork, setNewNetwork] = useState({
    network_name: "",
    country: "",
    timezone: "",
    device_limit: "",
    location: "",
  });
  const [timeZones, setTimeZones] = useState([]);
  const [edgeMacAddress, setEdgeMacAddress] = useState(""); // comma-separated MACs
  const [edgeMacError, setEdgeMacError] = useState("");
  const [edgeDeviceTypes, setEdgeDeviceTypes] = useState({ AP: false, SW: false }); // ADD THIS LINE
  const [edgeDeviceTypeOpen, setEdgeDeviceTypeOpen] = useState(false);
  const edgeDeviceTypeRef = useRef(null);

  const [managedDevices, setManagedDevices] = useState([]);

  const [showManagedDeviceForm, setShowManagedDeviceForm] = useState(false);
  const [tableQuery, setTableQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });

  const [managedDevice, setManagedDevice] = useState({
    name: "",
    ipAddress: "",
    macAddress: "",
    serialNo: "",
    deviceType: "",
    communicationProtocol: [],
  });

  useEffect(() => {
    getDeviceDetails();
    setActiveTab("snmp");
    fetchSnmpTemplates();
    getEdgeDevices();
    fetchNetworkIds();
    fetchTimeZones();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        edgeDeviceTypeRef.current &&
        !edgeDeviceTypeRef.current.contains(e.target)
      ) {
        setEdgeDeviceTypeOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getDeviceDetails = async () => {
    try {
      setLoading(true);
      const api = new allApi();
      const devicesResponse = await api.getRequest("api/devices");
      if (devicesResponse) {
        setDevicesResponse(devicesResponse);
        setDeviceListings(devicesResponse);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching device data:", error);
      setLoading(false);
    }
  };

  const fetchSnmpTemplates = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/snmp/templates/all");
      console.log("RES", response);
      if (response) {
        setSnmpTemplates(response);
      } else {
        console.error(
          "Error fetching SNMP templates: Invalid response or data structure."
        );
      }
    } catch (error) {
      console.error("Error fetching SNMP templates:", error);
    }
  };

  async function getEdgeDevices() {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/gateway/all");
      if (response && Array.isArray(response)) {
        setGateways(response);
      }
    } catch (error) {
      setError("Error fetching gateways");
    }
  }

  const syncHttpButtonState = (fields) => {
    const isComplete =
      Boolean(fields.serialNo) &&
      Boolean(fields.macAddress) &&
      Boolean(fields.deviceName) &&
      Boolean(fields.deviceType) &&
      Boolean(fields.networkId);

    setIsAddHttpDisabled(!isComplete);
    setIsAddEdgeDisabled(!isComplete);
  };

  const macRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

  // Validates a comma-separated list of MAC addresses, e.g. "aa:bb:cc:dd:ee:ff, 11:22:33:44:55:66"
  const validateMacList = (value) => {
    if (!value || !value.trim()) return false;
    const macs = value.split(",").map((m) => m.trim()).filter(Boolean);
    return macs.length > 0 && macs.every((mac) => macRegex.test(mac));
  };

  const syncEdgeButtonState = (macValue, deviceTypesObj, fields = httpsFields) => {
    const macValid = validateMacList(macValue);
    const typeSelected = deviceTypesObj.AP || deviceTypesObj.SW;
    const isComplete =
      Boolean(fields.serialNo) &&
      macValid &&
      Boolean(fields.deviceName) &&
      typeSelected &&
      Boolean(fields.networkId);
    setIsAddEdgeDisabled(!isComplete);
  };

  const handleEdgeMacChange = (e) => {
    const value = e.target.value;
    setEdgeMacAddress(value);
    if (value && !validateMacList(value)) {
      setEdgeMacError(
        "Enter valid MAC address(es) separated by commas, e.g. aa:bb:cc:dd:ee:ff, 11:22:33:44:55:66"
      );
    } else {
      setEdgeMacError("");
    }
    syncEdgeButtonState(value, edgeDeviceTypes);
  };

  const handleEdgeDeviceTypeChange = (type) => {
    setEdgeDeviceTypes((prev) => {
      const updated = { ...prev, [type]: !prev[type] };
      syncEdgeButtonState(edgeMacAddress, updated);
      return updated;
    });
  };

  const handleManagedDeviceChange = (e) => {
    const { name, value } = e.target;

    setManagedDevice((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleProtocolChange = (protocol) => {
    setManagedDevice((prev) => {
      const exists = prev.communicationProtocol.includes(protocol);

      return {
        ...prev,
        communicationProtocol: exists
          ? prev.communicationProtocol.filter((item) => item !== protocol)
          : [...prev.communicationProtocol, protocol],
      };
    });
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab == "mqtt") {
      setMqttFields({ ...mqttDefaultValues });
    } else if (tab == "tr069") {
      setTr069Fields({ ...tr069Fields });
    } else if (tab === "https") {
      syncHttpButtonState(httpsFields);
    }
  };

  const handleDiscover = async () => {
    try {
      setIsLoading(true);
      const api = new allApi();
      const payload = {
        startIP: snmpFields.startIp,
        endIP: snmpFields.endIp,
        snmpID: snmpFields.snmpTemplate,
        ipType: snmpFields.ipType,
        gateway_id: parseInt(snmpFields.snmpGateway),
      };
      const response = await api.postRequest("api/snmp/discover", "", payload);
      if (response.status === 204 || response.data === "No device discovered") {
        setDiscoverResponseData([]);
        setErrorDiscovery(true);
      } else {
        setDiscoverResponseData(response.data);
        setErrorDiscovery(false);
      }
    } catch (error) {
      console.error("Error discovering devices:", error);
      setErrorDiscovery(true);
    } finally {
      setIsLoading(false);
      setSnmpFields({
        startIp: "",
        endIp: "",
        ipType: "",
        snmpTemplate: "",
        snmpGateway: "",
      });
    }
  };

  const isValidIP = (ip) => {
    const trimmedIp = ip.trim();
    const regex =
      /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-7]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;
    return regex.test(trimmedIp);
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;

    if (activeTab === "snmp") {
      setSnmpFields((prevState) => {
        const newState = {
          ...prevState,
          [fieldName]: value,
        };
        if (
          newState.startIp &&
          newState.endIp &&
          newState.ipType &&
          newState.snmpTemplate
        ) {
          setIsDiscoverButtonDisabled(false);
        } else {
          setIsDiscoverButtonDisabled(true);
        }
        return newState;
      });
    } else if (activeTab === "mqtt") {
      setMqttFields((prevState) => {
        const newState = {
          ...prevState,
          [fieldName]: value,
        };
        if (
          newState.start_ip &&
          newState.snmp_template &&
          newState.mac_address
        ) {
          setIsAddMqttDisabled(false);
        } else {
          setIsAddMqttDisabled(true);
        }
        return newState;
      });
    } else if (activeTab === "tr069") {
      setTr069Fields((prevState) => {
        const newState = {
          ...prevState,
          [fieldName]: value,
        };

        validateFields(newState);
        return newState;
      });
    } else if (activeTab === "https") {
      const { value } = e.target;
      setHttpsFields((prevState) => {
        const newState = {
          ...prevState,
          [fieldName]: value,
        };

        if (activeTab === "https") {
          syncHttpButtonState(newState);
        } else {
          syncEdgeButtonState(edgeMacAddress, edgeDeviceTypes, newState);
        }
        return newState;
      });
    }
  };

  const validateFields = (fields) => {
    let errors = {};
    if (devicesResponse.some((device) => device.serialNo === fields.serialNo)) {
      errors.serialNo = "Serial Number must be unique.";
    }
    if (devicesResponse.some((device) => device.oui === fields.oui)) {
      errors.oui = "OUI must be unique.";
    }
    if (
      devicesResponse.some(
        (device) => device.productClass === fields.productClass
      )
    ) {
      errors.productClass = "Product Class must be unique.";
    }

    setValidationErrors(errors);
    setTRDisabled(
      Object.keys(errors).length > 0 ||
      !fields.manufacturer ||
      !fields.oui ||
      !fields.serialNo ||
      !fields.productClass
    );
  };

  async function getEdgeDevices() {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/gateway/all");
      if (response && Array.isArray(response)) {
        setGateways(response);
      }
    } catch (error) {
      setError(localizationStrings?.gatewayError);
    }
  }

  const handleHTTPSDevice = async () => {
    setIsAddHttpDisabled(true);
    setIsAddEdgeDisabled(true);
    try {
      const api = new allApi();
      const payload = {
        macAddress: httpsFields.macAddress,
        serialNumber: httpsFields.serialNo,
        deviceName: httpsFields.deviceName,
        deviceType: httpsFields.deviceType,
        networkId: httpsFields.networkId,
      };
      const response = await api.postRequest("api/http/onboard", "", payload);

      if (response.status === "OK") {
        const clearedFields = {
          serialNo: "",
          macAddress: "",
          deviceName: "",
          deviceType: "",
          networkId: "",
        };
        setHttpsFields(clearedFields);
        syncHttpButtonState(clearedFields);

        setShowSuccessModal(true);
        await getEdgeDevices();
      } else {
        console.error("Error adding device:", response);
      }
    } catch (error) {
      if (error.response.data.message === "Device already exists.") {
        setShowDeviceExistPopup(true);
        console.log("device already present", error.response.data.message);
      }
      console.error("Network error:", error);
    } finally {
      syncHttpButtonState(httpsFields);
    }
  };

  const addManagedDevice = () => {
    if (
      !managedDevice.name ||
      !managedDevice.ipAddress ||
      !managedDevice.macAddress ||
      !managedDevice.deviceType ||
      managedDevice.communicationProtocol.length === 0
    ) {
      return;
    }

    setManagedDevices((prev) => [
      ...prev,
      {
        ...managedDevice,
        id: Date.now(),
      },
    ]);

    setManagedDevice({
      name: "",
      ipAddress: "",
      macAddress: "",
      serialNo: "",
      deviceType: "",
      communicationProtocol: [],
    });

    setShowManagedDeviceForm(false);
  };

  const cancelClicked = () => {
    if (activeTab === "snmp") {
      setSnmpFields({
        startIp: "",
        endIp: "",
        ipType: "",
        snmpTemplate: "",
        snmpGateway: "",
      });
    } else if (activeTab === "mqtt") {
      setMqttFields({ ...mqttDefaultValues });
    } else if (activeTab === "tr069") {
      setTr069Fields({
        manufacturer: "",
        oui: "",
        serialNo: "",
        productClass: "",
      });
      setTRDisabled(true);
    } else if (activeTab === "https") {
      const clearedFields = {
        serialNo: "",
        macAddress: "",
        deviceName: "",
        deviceType: "",
        networkId: "",
      };
      setHttpsFields(clearedFields);
      setIsAddHttpDisabled(true);
      setIsAddEdgeDisabled(true);
    }
  };

  const addMqttDevice = async () => {
    try {
      const api = new allApi();
      let response = await api.postRequest(`api/mqtt/onboard`, "", mqttFields);
      setMqttFields({ ...mqttDefaultValues });
      setMqttDeviceMessage(response.msg);
      if (response && response.status === 200) {
        const addedDevice = response.data;
        addDeviceToListing(addedDevice);
        setDiscoverResponseData((prevData) => [...prevData, addedDevice]);
      } else {
        console.error("Failed to add MQTT device. Response:", response);
      }
    } catch (error) {
      console.error("Error adding new device:", error);
    }
  };

  const handleAddDeviceToListing = async (device) => {
    try {
      addDeviceToListing(device);
      setShowSuccessModal(false);
    } catch (error) {
      console.error("Error adding device to listing:", error);
    }
  };

  const checkFields = () => {
    for (const field in mqttFields) {
      if (field !== "gateway_id" && mqttFields[field] === "") {
        return true;
      }
    }
    for (const field in snmpFields) {
      if (snmpFields[field] === "") {
        return true;
      }
    }

    return false;
  };

  const closePopUp = () => {
    setMqttFields({
      start_ip: "",
      mac_address: "",
      snmp_template: "",
    });
  };

  const addTRDevice = async () => {
    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    try {
      const api = new allApi();
      const response = await api.postRequest("api/tr069/onboard/device", "", {
        Manufacture: tr069Fields.manufacturer,
        OUI: tr069Fields.oui,
        ProductClass: tr069Fields.productClass,
        SerialNumber: tr069Fields.serialNo,
      });

      if (response) {
        setTr069Fields({
          manufacturer: "",
          oui: "",
          serialNo: "",
          productClass: "",
        });
        setTr069SuccessModal(true);
        setValidationErrors({});
        setTr069Fields({
          manufacturer: "",
          oui: "",
          serialNo: "",
          productClass: "",
        });
      }
    } catch (error) {
      let errorMsg = "An error occurred while adding the TR-069 device.";

      // Safely check if response and status exist
      const statusCode = error?.response?.status;

      if (statusCode === 400) {
        errorMsg += "\n1. Use Unique Serial Number, OUI and Product Class";
      } else if (statusCode === 500) {
        errorMsg += "\n2. Internal Server Error. Please try again later.";
      } else if (!statusCode) {
        errorMsg += "\n3. Server not reachable or network issue.";
      } else {
        errorMsg += `\n4. Unexpected error (Status code: ${statusCode})`;
      }

      setTr069ErrorMessage(errorMsg);
      setTr069ErrorModal(true);
    }
  };

  const handleDeviceSelect = (device) => {
    console.log("Selected Device:", device);
    const selectedIndex = selectedDevices.findIndex(
      (selectedDevice) => selectedDevice.deviceIP === device.deviceIP
    );
    if (selectedIndex === -1) {
      setSelectedDevices([...selectedDevices, device]);
    } else {
      const updatedDevices = [...selectedDevices];
      updatedDevices.splice(selectedIndex, 1);
      setSelectedDevices(updatedDevices);
    }
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectedDevices(isChecked ? discoverResponseData : []);
    setSelectAllChecked(isChecked);
  };

  const handleAddDevices = async () => {
    if (selectedDevices.length === 0) {
      setShowNoDeviceSelectedPopup(true);
      return;
    } else {
      setSuccessMessageVisible(true);
    }
    try {
      const api = new allApi();
      let array = gateways.filter(
        (item) => item.gateway_name == selectedDevices[0].gateway_name
      );
      const payload = selectedDevices.map((device) => ({
        deviceIP: device.deviceIP,
        deviceName: device.deviceName,
        deviceMac: device.deviceMac,
        deviceType: device.deviceType,
        snmpID: device.snmpID,
        workingMode: device.workingMode,
        deviceModel: device.deviceModel,
        gateway_id: array.length > 0 ? array[0].request_id : null,
        protocol_type: "SNMP",
      }));
      const response = await api.postRequest("api/snmp/add_snmp", "", payload);
      if (response) {
        selectedDevices.forEach((device) => {
          handleAddDeviceToListing(device);
        });
        setSelectedDevices([]);
        setDiscoverResponseData((prevData) =>
          prevData.filter(
            (device) =>
              !selectedDevices.some(
                (selectedDevice) => selectedDevice.deviceIP === device.deviceIP
              )
          )
        );
        setShowSuccessPopup(true);
      } else {
        console.error("Failed to add device. Response:", response);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.msg ===
        "Duplicate key value violates unique constraint."
      ) {
        setErrorMessage(localizationStrings?.deviceIpExists);
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
          setErrorMessage("");
        }, 3000);
      } else {
        console.error("Error adding device:", error);
      }
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    setTr069SuccessModal(false);
    setTr069ErrorModal(false);
    navigate("/device-listing");
    closePopUp();
  };
  const successhandleClose = () => setShowSuccessModal(false);
  const successhandleShow = () => setShowSuccessModal(true);
  const disableDiscover = !(
    snmpFields.startIp &&
    snmpFields.endIp &&
    snmpFields.ipType &&
    snmpFields.snmpTemplate &&
    snmpFields.snmpGateway &&
    !startIpError &&
    !endIpError
  );

  const handleStartIp = (e) => {
    const value = e.target.value;
    setSnmpFields({ ...snmpFields, startIp: value });
    if (value && !isValidIP(value)) {
      setStartIpError("Please enter valid IP");
    } else {
      setStartIpError("");
    }
  };
  const handleEndIp = (e) => {
    const value = e.target.value;
    setSnmpFields({ ...snmpFields, endIp: value });
    if (value && !isValidIP(value)) {
      setEndIpError("Please enter valid IP");
    } else {
      setEndIpError("");
    }
  };

  const fetchNetworkIds = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/network/getAssociatedNetwork");
      if (
        response &&
        response.status === "OK" &&
        Array.isArray(response.response)
      ) {
        setNetworkIds(
          response.response.map((network) => ({
            network_id: network.network_id,
            network_name: network.network_name,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching network IDs:", error);
    }
  };

  const fetchTimeZones = async () => {
    try {
      const api = new allApi();
      const response = await api.getRequest("api/network/timeZone");
      if (
        response &&
        response.status === "OK" &&
        Array.isArray(response.response)
      ) {
        setTimeZones(response.response);
      }
    } catch (error) {
      console.error("Error fetching time zones:", error);
    }
  };

  const createNetwork = async () => {
    try {
      const api = new allApi();
      const payload = {
        networkName: newNetwork.network_name,
        country: newNetwork.country,
        device_limit: Number(newNetwork.device_limit),
        network_location: newNetwork.location,
        network_timezone: newNetwork.timezone,
        nwStatus: "online",
      };
      const response = await api.postRequest(
        "api/network/createNetwork",
        "",
        payload
      );
      if (response && response.status === "OK") {
        setShowCreateNetworkModal(false);
        setNewNetwork({
          network_name: "",
          country: "",
          timezone: "",
          device_limit: "",
          location: "",
        });
        fetchNetworkIds();
      } else {
        setError(response?.message || "Failed to create network");
      }
    } catch (error) {
      setError("Network creation failed");
      console.error(error);
    }
  };

  const discoveredRows = sortRows(
    searchRows(discoverResponseData || [], tableQuery, [
      "deviceIP",
      "deviceName",
      "deviceType",
      "gateway_name",
      "deviceMac",
      "deviceModel",
      "snmpVer",
      "status",
    ]),
    sortConfig.key,
    sortConfig.direction
  );

  const sortDiscovered = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  return (
    <div className="nms-dash">
      {error && <div className="error">{error}</div>}
      <div className="inc-card ch-100">
        <div className="inc-card-title">
          <ul className="nav nav-underline" id="discoverTab" role="tablist">
            <li className="nav-item" role="discover">
              <button
                className={`nav-link ${activeTab === "snmp" ? "active" : ""}`}
                id="snmp-tab"
                data-bs-toggle="tab"
                data-bs-target="#snmp-tab-pane"
                type="button"
                role="tab"
                aria-controls="snmp-tab-pane"
                aria-selected={activeTab === "snmp" ? "true" : "false"}
                onClick={() => handleTabChange("snmp")}
              >
                SNMP
              </button>
            </li>
            <li className="nav-item" role="discover">
              <button
                className={`nav-link ${activeTab === "mqtt" ? "active" : ""}`}
                id="mqtt-tab"
                data-bs-toggle="tab"
                data-bs-target="#mqtt-tab-pane"
                type="button"
                role="tab"
                aria-controls="mqtt-tab-pane"
                aria-selected={activeTab === "mqtt" ? "true" : "false"}
                onClick={() => handleTabChange("mqtt")}
              >
                MQTT
              </button>
            </li>
            <li className="nav-item" role="discover">
              <button
                className={`nav-link ${activeTab === "tr069" ? "active" : ""}`}
                id="tr069-tab"
                data-bs-toggle="tab"
                data-bs-target="#tr69-tab-pane"
                type="button"
                role="tab"
                aria-controls="tr69-tab-pane"
                aria-selected={activeTab === "tr069" ? "true" : "false"}
                onClick={() => handleTabChange("tr069")}
              >
                TR-069
              </button>
            </li>
            <li className="nav-item" role="discover">
              <button
                className={`nav-link ${activeTab === "https" ? "active" : ""}`}
                id="https-tab"
                data-bs-toggle="tab"
                data-bs-target="#https-tab-pane"
                type="button"
                role="tab"
                aria-controls="https-tab-pane"
                aria-selected={activeTab === "https" ? "true" : "false"}
                onClick={() => handleTabChange("https")}
              >
                HTTPS
              </button>
            </li>
          </ul>
          <div className="inc-card-button">
            {activeTab === "snmp" && (
              <NmsTableSearch
                value={tableQuery}
                onChange={setTableQuery}
                placeholder={localizationStrings?.search || "Search devices"}
              />
            )}
            {activeTab === "snmp" && (
              <button
                className="text-btn primary-btn"
                data-bs-toggle="modal"
                disabled={selectedDevices.length < 2}
                data-bs-target={
                  selectedDevices.length === 0
                    ? "#noDeviceSelectedPopup"
                    : "#deviceAddedMessagePopup"
                }
                onClick={() => {
                  if (selectedDevices.length === 0) {
                    setShowNoDeviceSelectedPopup(true);
                  } else {
                    setShowSuccessMessageModal(true);
                    handleAddDevices();
                  }
                }}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                {localizationStrings?.addDevices}
              </button>
            )}
          </div>
        </div>
        <div className="inc-card-body">
          <div>
            <div className="tab-content mt-4" id="discoverTabContent">
              <div
                className={`tab-pane fade ${activeTab === "snmp" && "active show"
                  }`}
                id="snmp-tab-pane"
                role="tabpanel"
              >
                {activeTab === "snmp" && (
                  <div>
                    <div className="discover-form">
                      <div className="row">
                        <div className="col-lg-6">
                          <label className="form-label">
                            {localizationStrings?.startIp}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={localizationStrings?.enterStartIp}
                            id="startIp"
                            name="startIp"
                            value={snmpFields.startIp}
                            onChange={handleStartIp}
                          />{" "}
                          {startIpError && (
                            <p className="text-danger">{startIpError}</p>
                          )}
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            {localizationStrings?.endIp}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={localizationStrings?.enterEndIp}
                            id="endIp"
                            name="endIp"
                            value={snmpFields.endIp}
                            onChange={handleEndIp}
                          />{" "}
                          {endIpError && (
                            <p className="text-danger">{endIpError}</p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4">
                          <label className="form-label">
                            {localizationStrings?.ipVersion}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="ipType"
                            name="ipType"
                            value={snmpFields.ipType}
                            onChange={(e) => handleInputChange(e, "ipType")}
                          >
                            <option value="">
                              {localizationStrings?.selectType}
                            </option>
                            <option value="IPv4">IPv4</option>
                            <option value="IPv6">IPv6</option>
                          </select>
                        </div>
                        <div className="col-lg-4">
                          <label className="form-label">
                            {localizationStrings?.deviceTemplate}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="snmpTemplate"
                            name="snmpTemplate"
                            value={snmpFields.snmpTemplate}
                            onChange={(e) =>
                              handleInputChange(e, "snmpTemplate")
                            }
                          >
                            <option value="">
                              {localizationStrings?.selectTemplate}
                            </option>
                            {snmpTemplates.map((template, index) => (
                              <option
                                key={index}
                                value={template.snmp_template_id}
                              >
                                {template.template_name}
                              </option>
                            ))}
                          </select>{" "}
                        </div>
                        <div className="col-lg-4">
                          <label className="form-label">
                            {localizationStrings?.gatewayName}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="snmpGateway"
                            name="snmpGateway"
                            value={snmpFields.snmpGateway}
                            onChange={(e) =>
                              handleInputChange(e, "snmpGateway")
                            }
                          >
                            <option value="">
                              {localizationStrings?.selectGateway}
                            </option>
                            <option value="">N/A</option>
                            {gateways.map((gateway, index) => (
                              <option key={index} value={gateway.request_id}>
                                {gateway.gateway_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="discover-button mt-3">
                        <button
                          className="text-btn btn-outline"
                          onClick={() => cancelClicked()}
                        >
                          {localizationStrings?.cancel}
                        </button>
                        <button
                          className={`text-btn primary-btn ${isDiscoverButtonDisabled ? "disabled" : ""
                            }`}
                          disabled={disableDiscover}
                          onClick={handleDiscover}
                          data-bs-target={
                            isDiscoverButtonDisabled
                              ? ""
                              : "#successMessagePopup"
                          }
                        >
                          {localizationStrings?.discover}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {showErrorMessage && (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                )}
                {discoverError && (
                  <div className="alert alert-danger" role="alert">
                    {localizationStrings?.invalidIpMsg}
                  </div>
                )}
                <div>
                  <div className="inc-card-table">
                    <table className="full-table">
                      <thead>
                        <tr>
                          <th>
                            <label className="checkbox">
                              <input
                                type="checkbox"
                                checked={selectAllChecked}
                                onChange={handleSelectAll}
                              />
                              <span className="indicator"></span>
                            </label>
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "deviceIP" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("deviceIP")}
                          >
                            {localizationStrings?.deviceId}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "deviceName" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("deviceName")}
                          >
                            {localizationStrings?.deviceName}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "deviceType" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("deviceType")}
                          >
                            {localizationStrings?.deviceType}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "gateway_name" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("gateway_name")}
                          >
                            {localizationStrings?.gatewayName}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "deviceMac" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("deviceMac")}
                          >
                            {localizationStrings?.deviceMac}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "deviceModel" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("deviceModel")}
                          >
                            {localizationStrings?.deviceModel}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th>{localizationStrings?.lastInform}</th>
                          <th
                            className={`inc-th-sort${sortConfig.key === "status" ? " is-active" : ""}`}
                            onClick={() => sortDiscovered("status")}
                          >
                            {localizationStrings?.health}
                            <i className="fa fa-sort" aria-hidden="true" />
                          </th>
                          <th>{localizationStrings?.action}</th>
                        </tr>
                        <tr className="search-border">
                          <td></td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="serialNumber"
                            />
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="deviceName"
                            />{" "}
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="deviceType"
                            />
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="deviceType"
                            />
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="softwareVersion"
                            />
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="ip"
                            />{" "}
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td>
                            <input
                              className="searchBox smallWidth"
                              type="text"
                              name="macAddress"
                            />
                            <i
                              className="fa fa-sort-amount-desc"
                              aria-hidden="true"
                            ></i>
                          </td>

                          <td>
                            <select className="searchBox smallWidth">
                              <option>All</option>
                              <option>Online</option>
                              <option>Offline</option>
                            </select>
                          </td>
                          <td></td>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <tbody>
                          <tr>
                            <td colspan="10">
                              <Loader />
                            </td>
                          </tr>
                        </tbody>
                      ) : errorDiscovery ? (
                        <tbody>
                          <tr>
                            <td colSpan="10">
                              <div className="nms-empty">
                                {localizationStrings?.noDeviceDiscovered}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {deviceManagedError ? (
                            <tr>
                              <td colSpan="9">
                                <div
                                  className="alert alert-danger"
                                  role="alert"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "small",
                                  }}
                                >
                                  <p>{deviceManagedError}</p>
                                </div>
                              </td>
                            </tr>
                          ) : discoveredRows.length ? (
                            discoveredRows.map((device, index) => (
                              <tr key={index}>
                                <td>
                                  <label className="checkbox">
                                    <input
                                      type="checkbox"
                                      checked={selectedDevices.some(
                                        (selectedDevice) =>
                                          selectedDevice.deviceIP ===
                                          device.deviceIP
                                      )}
                                      onChange={() =>
                                        handleDeviceSelect(device)
                                      }
                                    />
                                    <span className="indicator"></span>
                                  </label>
                                </td>
                                <td>{device.deviceIP}</td>
                                <td>{device.deviceName}</td>
                                <td>{device.deviceType}</td>
                                <td>{device.gateway_name}</td>
                                <td>{device.deviceMac}</td>
                                <td>{device.deviceModel}</td>
                                <td>{device.snmpVer}</td>
                                <td>
                                  <span
                                    className={`d-status ${device.status === "online"
                                      ? "online"
                                      : "offline"
                                      }`}
                                  >
                                    {device.status === "online"
                                      ? "Online"
                                      : "Offline"}
                                  </span>
                                </td>
                                <td>
                                  <div className="button-group">
                                    <button title="Edit">
                                      <i
                                        className="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <button title="Delete">
                                      <i
                                        className="fa fa-trash"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <button
                                      className="text-btn primary-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deviceAddedMessagePopup"
                                      disabled={selectedDevices.length === 0}
                                    >
                                      <i
                                        className="fa fa-plus"
                                        aria-hidden="true"
                                      ></i>
                                      {localizationStrings?.add}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10">
                                <div className="nms-empty">
                                  {localizationStrings?.noDeviceDiscovered ||
                                    localizationStrings?.noData}
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="mqtt-tab-pane" role="tabpanel">
                {activeTab === "mqtt" && (
                  <div>
                    <div className="discover-form">
                      <div className="row">
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">
                            {localizationStrings?.startIp}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={localizationStrings?.enterIp}
                            id="startIp"
                            name="startIp"
                            value={mqttFields.start_ip}
                            onChange={(e) => handleInputChange(e, "start_ip")}
                          />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">
                            {localizationStrings?.macAddress}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder={localizationStrings?.enterMacAddress}
                            id="mac_address"
                            name="mac_address"
                            value={mqttFields.mac_address}
                            onChange={(e) =>
                              handleInputChange(e, "mac_address")
                            }
                          />
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">
                            {localizationStrings?.deviceTemplate}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="snmpTemplate"
                            name="snmpTemplate"
                            value={mqttFields.snmp_template}
                            onChange={(e) =>
                              handleInputChange(e, "snmp_template")
                            }
                          >
                            <option value="">
                              {localizationStrings?.selectTemplate}
                            </option>
                            {snmpTemplates.map((template, index) => (
                              <option
                                key={index}
                                value={template.snmp_template_id}
                              >
                                {template.template_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-6 mb-3">
                          <label className="form-label">
                            {localizationStrings?.gateway}
                          </label>
                          <select
                            className="form-select"
                            id="snmpTemplate"
                            name="snmpTemplate"
                            value={mqttFields.gateway_id}
                            onChange={(e) => handleInputChange(e, "gateway_id")}
                          >
                            <option value="">
                              {localizationStrings?.selectGateway}
                            </option>
                            {gateways.map((gateway, index) => (
                              <option key={index} value={gateway.request_id}>
                                {gateway.gateway_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="discover-button mt-3">
                        <button
                          type="button"
                          className="text-btn btn-outline"
                          onClick={() => cancelClicked()}
                        >
                          {localizationStrings?.cancel}
                        </button>
                        <button
                          type="button"
                          className="text-btn primary-btn"
                          disabled={isAddMqttDisabled}
                          onClick={() => {
                            addMqttDevice();
                            setShowSuccessModal(true);
                          }}
                        >
                          {localizationStrings?.add}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="tab-pane fade" id="tr69-tab-pane" role="tabpanel">
                {activeTab === "tr069" && (
                  <div>
                    <div className="discover-form">
                      <div className="row">
                        <div className="col-lg-6">
                          <label htmlFor="manufacture" className="form-label">
                            {localizationStrings?.manufacture}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="manufacture"
                            name="manufacturer"
                            value={tr069Fields.manufacturer}
                            onChange={(e) =>
                              handleInputChange(e, "manufacturer")
                            }
                          />
                        </div>
                        <div className="col-lg-6">
                          <label htmlFor="oui" className="form-label">
                            {localizationStrings?.oui}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="oui"
                            name="oui"
                            value={tr069Fields.oui}
                            onChange={(e) => handleInputChange(e, "oui")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label htmlFor="serialNo" className="form-label">
                            {localizationStrings?.serialNumber}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="serialNo"
                            name="serialNo"
                            value={tr069Fields.serialNo}
                            onChange={(e) => handleInputChange(e, "serialNo")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label htmlFor="productClass" className="form-label">
                            {localizationStrings?.productClass}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="productClass"
                            name="productClass"
                            value={tr069Fields.productClass}
                            onChange={(e) =>
                              handleInputChange(e, "productClass")
                            }
                          />
                        </div>
                        <div className="discover-button mt-3">
                          <button
                            type="button"
                            className="text-btn btn-outline"
                            onClick={() => cancelClicked()}
                          >
                            {localizationStrings?.cancel}
                          </button>
                          <button
                            type="button"
                            className="text-btn primary-btn"
                            onClick={addTRDevice}
                          >
                            {localizationStrings?.add}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="tab-pane fade"
                id="https-tab-pane"
                role="tabpanel"
              >
                {activeTab === "https" && (
                  <div>
                    <div className="discover-form">
                      <div className="row">
                        <div className="col-lg-6">
                          <label htmlFor="manufacture" className="form-label">
                            {localizationStrings?.serialNumber}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="serialNo"
                            name="serialNo"
                            value={httpsFields.serialNo}
                            onChange={(e) => handleInputChange(e, "serialNo")}
                          />
                        </div>
                        <div className="col-lg-6">
                          <label htmlFor="oui" className="form-label">
                            {localizationStrings?.macAddress}
                            <span className="text-danger">*</span>
                          </label>
                          <InputMask
                            autoComplete="off"
                            id="macAddress"
                            onChange={(e) => handleInputChange(e, "macAddress")}
                            type="text"
                            mask="**:**:**:**:**:**"
                            placeholder="aa:bb:cc:dd:ee:ff"
                            data-type="mac"
                            className="form-control"
                            ref={macAddressRef}
                            spellCheck="false"
                            formatChars={{
                              "*": "[0-9A-Fa-f]",
                            }}
                            value={httpsFields.macAddress}
                          />
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="oui" className="form-label">
                            {localizationStrings?.deviceName}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="deviceName"
                            name="deviceName"
                            value={httpsFields.deviceName}
                            onChange={(e) => handleInputChange(e, "deviceName")}
                          />
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="protocolType" className="form-label">
                            {localizationStrings?.deviceType}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="deviceType"
                            name="deviceType"
                            value={httpsFields.deviceType}
                            onChange={(e) => handleInputChange(e, "deviceType")}
                          >
                            <option value="">
                              {localizationStrings?.selectDeviceType}
                            </option>
                            <option value="AP">AP</option>
                            <option value="SW">Switch</option>
                          </select>
                        </div>
                        <div className="col-lg-4">
                          <label htmlFor="networkId" className="form-label">
                            Network ID<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="networkId"
                            name="networkId"
                            value={httpsFields.networkId}
                            onChange={(e) => {
                              handleInputChange(e, "networkId");
                              if (e.target.value === "create") {
                                setShowCreateNetworkModal(true);
                              }
                            }}
                          >
                            <option value="" disabled hidden>
                              {localizationStrings?.chooseNetwork ||
                                "Choose Network"}
                            </option>
                            <option value="create">
                              {localizationStrings?.createNetwork ||
                                "Create Network"}
                            </option>
                            {networkIds.map((net) => (
                              <option
                                key={net.network_id}
                                value={net.network_id}
                              >
                                {net.network_name || net.network_id}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="discover-button mt-3">
                          <button
                            type="button"
                            className="text-btn btn-outline"
                            onClick={() => {
                              cancelClicked();
                            }}
                          >
                            {localizationStrings?.cancel}
                          </button>
                          <button
                            type="button"
                            className="text-btn primary-btn"
                            onClick={() => {
                              handleHTTPSDevice();
                            }}
                            disabled={isAddHttpDisabled}
                          >
                            {localizationStrings?.add}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`modal fade`}
              id="successMessagePopup"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content inc-modal">
                  <div className="modal-body success-msg">
                    <img src={waitIcon} alt="Success" />
                    <p>
                      {deviceAddedMessageVisible
                        ? localizationStrings?.deviceAddedSuccessfully
                        : localizationStrings?.deviceAddingInfo}
                    </p>
                    <button
                      className="text-btn primary-btn"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setShowSuccessMessageModal(false);
                      }}
                    >
                      {localizationStrings?.ok}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`modal fade`}
              id="noDeviceSelectedPopup"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content inc-modal">
                  <div className="modal-body success-msg">
                    <img src={errorIcon} alt="error" />
                    <p>
                      {localizationStrings?.noDeviceSelect1}
                      <br />
                      {localizationStrings?.noDeviceSelect2}.
                    </p>
                    <button
                      className="text-btn primary-btn"
                      data-bs-dismiss="modal"
                      onClick={() => setShowNoDeviceSelectedPopup(false)}
                    >
                      {localizationStrings?.ok}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              show={tr069SuccessModal}
              onHide={() => setTr069SuccessModal(false)}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="inc-alert"
            >
              <span className="success-icon">
                <img src={successIcon} alt="Success" />
              </span>
              <h3>{localizationStrings?.success}</h3>
              <p>{localizationStrings?.trDiscoverInfo}!</p>
              <Button
                onClick={() => {
                  setTr069SuccessModal(false);
                  navigate("/device-listing");
                }}
              >
                {localizationStrings?.ok}
              </Button>
            </Modal>
            <Modal
              show={tr069ErrorModal}
              onHide={() => setTr069ErrorModal(false)}
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="inc-alert"
            >
              <span className="error-icon">
                <img src={errorIcon} alt="Error" />
              </span>
              <h3>{localizationStrings?.error}</h3>
              <p style={{ whiteSpace: "pre-line" }}>{tr069ErrorMessage}</p>
              <Button
                onClick={() => {
                  setTr069ErrorModal(false);
                  navigate("/device-listing");
                }}
              >
                {localizationStrings?.ok}
              </Button>
            </Modal>

            {/* Device Added Successfully Popup */}
            <div
              className={`modal fade
                `}
              id="deviceAddedMessagePopup"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content inc-modal">
                  <div className="modal-body success-msg">
                    <img src={waitIcon} alt="wait" />
                    <p>{localizationStrings?.deviceAddInfo}.</p>
                    <button
                      className="text-btn primary-btn"
                      data-bs-dismiss="modal"
                      onClick={handleAddDevices}
                    >
                      {localizationStrings?.ok}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert"
      >
        <span className="success-icon">
          <img src={successIcon} alt="Success" />
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.requestSentToClientSuccessfully}!</p>
        <Button
          onClick={() => {
            setShowSuccessPopup(false);
            navigate("/device-listing");
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert"
      >
        <span className="success-icon">
          <img src={successIcon} alt="Success" />
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.deviceDiscoveredSuccessfully}!</p>
        <Button
          onClick={() => handleAddDeviceToListing(discoverResponseData[0])}
        >
          {localizationStrings?.addDevice}
        </Button>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={handleSuccessModalClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inc-alert"
      >
        <span className="success-icon">
          <i className="icon done"></i>
        </span>
        <h3>{localizationStrings?.success}</h3>
        <p>{localizationStrings?.deviceAddedSuccessfully}!</p>
        <Button
          onClick={() => {
            handleSuccessModalClose();
          }}
        >
          {localizationStrings?.ok}
        </Button>
      </Modal>

      {showCreateNetworkModal && (
        <div
          className={"modal fade customModal show"}
          id="createNetwork"
          style={{ display: "block", zIndex: 1009 }}
        >
          <div className="modal-dialog modal-dialog-centered create-usr-pop">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="create-network-modal"
                  style={{ color: "#007bff", fontWeight: 600 }}
                >
                  Create Network
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  data-bs-dismiss="modal"
                  onClick={() => setShowCreateNetworkModal(false)}
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "12px",
                    fontSize: "1rem",
                    width: "1.5rem",
                    height: "1.5rem",
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label className="form-label">
                        Network Name<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={newNetwork.network_name}
                        onChange={(e) =>
                          setNewNetwork({
                            ...newNetwork,
                            network_name: e.target.value,
                          })
                        }
                        placeholder="Enter network name"
                      />
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="form-label">
                        Country<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={newNetwork.country}
                        onChange={(e) =>
                          setNewNetwork({
                            ...newNetwork,
                            country: e.target.value,
                          })
                        }
                        placeholder="Enter country"
                      />
                    </div>
                    <div className="col-lg-4 mb-3">
                      <label className="form-label">
                        Timezone<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        value={newNetwork.timezone}
                        onChange={(e) =>
                          setNewNetwork({
                            ...newNetwork,
                            timezone: e.target.value,
                          })
                        }
                      >
                        <option value="">Select timezone</option>
                        {timeZones.map((tz, idx) => (
                          <option key={idx} value={tz}>
                            {tz}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        Device Limit (max 20)
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min={1}
                        max={20}
                        value={newNetwork.device_limit}
                        onChange={(e) => {
                          let val = e.target.value;
                          if (val > 20) val = 20;
                          setNewNetwork({ ...newNetwork, device_limit: val });
                        }}
                        placeholder="Max 20 devices"
                      />
                    </div>
                    <div className="col-lg-6 mb-3">
                      <label className="form-label">
                        Location<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={newNetwork.location}
                        onChange={(e) =>
                          setNewNetwork({
                            ...newNetwork,
                            location: e.target.value,
                          })
                        }
                        placeholder="Enter location"
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer pb-0">
                <button
                  type="button"
                  className="btn btn-outline"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShowCreateNetworkModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="text-btn primary-btn"
                  onClick={createNetwork}
                  disabled={
                    !newNetwork.network_name ||
                    !newNetwork.country ||
                    !newNetwork.timezone ||
                    !newNetwork.device_limit ||
                    !newNetwork.location
                  }
                >
                  Create
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDeviceExistPopup && (
        <div className="customModal confirm-modal">
          <div className="modal-dialog modal-dialog-centered small">
            <div className="modal-content inc-modal">
              <div className="modal-body">
                <img src={errorIcon} alt="error" />
                <h3>{localizationStrings?.deviceExists}</h3>
                <div className="modal-footer">
                  <button
                    className="text-btn primary-btn"
                    onClick={() => setShowDeviceExistPopup(false)}
                  >
                    {localizationStrings?.close}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceDiscovery;
